import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle'; // Import DialogTitle
import DialogContent from '@mui/material/DialogContent'; // Import DialogContent
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

function UserDataNotFound({ isOpen, onClose }) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>User not found!</DialogTitle> {/* Use DialogTitle */}
      <DialogContent>
        {' '}
        {/* Use DialogContent */}
        User data not found in the application. Please try again.
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UserDataNotFound;
